<template>
  <v-row justify="end" class="mr-12">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn class="text-capitalize text-white button-config" v-bind="props">
          Cadastrar StakeHolder Externo
          <v-icon right class="ml-1">mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Cadastrar StakeHolder Externo</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="nome"
                    required
                    label="Nome*"
                    :rules="nomeRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="email"
                    label="E-mail*"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module StakeHolderEModal
 * @desc Modal que cria o StakeHolder.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o
 * diálogo está aberto ou fechado.
 * @vue-data {string} [nome=''] - O nome associado ao componente.
 * @vue-data {string} [email=''] - O endereço de email associado ao componente.
 * @vue-data {number} [idProjeto=null] - O ID do projeto associado ao
 * componente, ou null se nenhum projeto estiver associado.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o stakeholder
 * externo ainda está sendo criado.
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  emits: ['stakeholderCriado'],
  data: () => ({
    dialog: false,
    nome: '',
    email: '',
    idProjeto: null,
    isLoading: false,
    nomeRules: [
      (v) => !!v || 'Nome é obrigatório',
      (v) => (v && v.length <= 68) || 'Nome deve ter no máximo 68 caracteres',
    ],
    emailRules: [
      (v) => !!v || 'E-mail é obrigatório',
      (v) =>
        // eslint-disable-next-line max-len
        // Esta regra foi tirada de: https://stackoverflow.com/questions/50039793/email-validation-n-vuetify-js
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Este e-mail não é válido',
      (v) => (v && v.length <= 68) || 'E-mail deve ter no máximo 68 caracteres',
    ],
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Envia o formulário de criação.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;
      const regex = /[a-zA-Z]/;
      if (isValid) {
        const data = {
          nome: this.nome,
          email: this.email,
        };
        try {
          console.log(regex.test(this.nome));
          if (!regex.test(this.nome)) {
            this.$toast.error(
              'Nome do stakeholder não pode ter apenas numeros ' +
                'e caracteres especiais.',
            );

            return;
          } else if (this.nome.charAt(0) === ' ') {
            this.$toast.error(
              'Nome do stakeholder não pode ser iniciado com espaços em branco.',
            );

            return;
          }

          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.post(
            `${apiUrl}/api/v1/stakeHolderE/projeto/${this.idProjeto}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(response.data.msg);
          this.$emit('stakeholderCriado');
          this.$router.push(`/projects/${this.idProjeto}/StackHolderE`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
          this.limpaFormulario();
        }
      }
    },

    /**
     * Método auxiliar para limpar os campos do formulário após o seu envio.
     */
    limpaFormulario() {
      this.nome = '';
      this.email = '';
    },
  },
};
</script>

<style scoped>
.button-config {
  background-color: #004984;
}
</style>
